(function () {
  "use strict";

  XlsImportDlgCtrl.$inject = ['$scope', 'xlsState', '$modalInstance'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsImportDlgCtrl', XlsImportDlgCtrl);

  function XlsImportDlgCtrl($scope, xlsState, $modalInstance) {
    $scope.xlsState = xlsState;

    $scope.done = function () {
      $modalInstance.close('done');
    };

    $scope.$watch('xlsState.importIdx', function () {
      $scope.progressPercent = 100 * xlsState.importIdx / xlsState.rows.length;
    });
  }

})();
